import { useContext } from "react"

import { WorkAccidentOccurrenceProvider, WorkAccidentOccurrenceContext } from "./provider"

interface IUseWorkAccidentOccurrenceReturn {
  handleSetIdOcorrenciaSelecionado: (idOcorrencia: number) => void
  idOcorrenciaSelecionado: number
}
const UseWorkAccidentOccurrence = (): IUseWorkAccidentOccurrenceReturn => {
  const {
    idOcorrenciaSelecionado,
    setIdOcorrenciaSelecionado
  } = useContext(WorkAccidentOccurrenceContext)

  const handleSetIdOcorrenciaSelecionado = (idOcorrencia: number) => {
    setIdOcorrenciaSelecionado(idOcorrencia)
  }

  return {
    handleSetIdOcorrenciaSelecionado,
    idOcorrenciaSelecionado
  }
}

export {
  UseWorkAccidentOccurrence,
  WorkAccidentOccurrenceProvider
}
